import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

export interface CreateClientAdminAccessSessionResponse {
	sessionId: string
	accessToken: string
	expiresAt: number
	adminId: string
	clientId: string
	appWebsite?: string
}

export interface CreateClientAdminAccessSessionPayload {
	reason: string
	adminId?: string
}

const createClientAdminAccessSession = async (
	clientId: string,
	payload: CreateClientAdminAccessSessionPayload | string
): Promise<CreateClientAdminAccessSessionResponse> => {
	try {
		const body = typeof payload === 'string' ? { reason: payload } : payload
		const { data } = await axios.post<CreateClientAdminAccessSessionResponse>(
			`management/client/${clientId}/admin-access/session`,
			body
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default createClientAdminAccessSession
